import React from "react";
import { ProjectDetailPageInitialState, PageNewState } from ".";

export const ProjectDetailPageContext = React.createContext({
  pageState: ProjectDetailPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
